const KEY = "ais_oral_custom_questions_v1";

function safeLoad() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (err) {
    console.error("[customQuestions] read failed", err);
    return [];
  }
}

function safeSave(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (err) {
    console.error("[customQuestions] write failed", err);
  }
}

export function loadCustomQuestions() {
  return safeLoad();
}

export function addCustomQuestions(newItems, source) {
  const list = safeLoad();
  const importId = `imp_${Date.now()}`;
  const added = newItems.map((q, i) => ({
    id: `cq_${Date.now()}_${i}`,
    text: q.text,
    sectionId: q.sectionId,
    groupId: q.groupId,
    importId,
    source: source || null,
    ts: Date.now(),
  }));
  const next = [...list, ...added];
  safeSave(next);
  return { added, importId, all: next };
}

export function deleteCustomQuestion(id) {
  const list = safeLoad().filter((q) => q.id !== id);
  safeSave(list);
  return list;
}

export function updateCustomQuestion(id, patch) {
  const list = safeLoad().map((q) =>
    q.id === id ? { ...q, ...patch, ts: Date.now() } : q
  );
  safeSave(list);
  return list;
}

export function deleteImportBatch(importId) {
  const list = safeLoad().filter((q) => q.importId !== importId);
  safeSave(list);
  return list;
}

export function clearAllCustomQuestions() {
  safeSave([]);
}
